import { motion } from "framer-motion";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between mb-8 flex-wrap gap-4">
      <div>
        <h1 className="text-3xl sm:text-4xl font-light font-display tracking-tighter text-white">{title}</h1>
        {subtitle && <p className="text-slate-400 mt-1.5 text-sm">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function Card({ children, className = "", ...props }) {
  return (
    <div className={`bg-[#0F172A] border border-slate-800 rounded-lg ${className}`} {...props}>{children}</div>
  );
}

export function KpiCard({ label, value, suffix, trend, tone = "default", index = 0 }) {
  const toneColor = {
    default: "text-white",
    green: "text-[#059669]",
    red: "text-[#DC2626]",
    gold: "text-[#C9A24B]",
  }[tone];
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.06 }}
      className="bg-[#0F172A] border border-slate-800 rounded-lg p-6"
    >
      <p className="text-[11px] font-semibold tracking-[0.2em] uppercase text-slate-500">{label}</p>
      <p className={`mt-3 text-4xl font-light font-display tracking-tighter ${toneColor}`}>
        {value}{suffix && <span className="text-2xl text-slate-500 ml-1">{suffix}</span>}
      </p>
      {trend && <p className="mt-2 text-xs text-slate-500">{trend}</p>}
    </motion.div>
  );
}

export function Badge({ children, tone = "slate" }) {
  const map = {
    slate: "bg-slate-700/40 text-slate-300 border-slate-600",
    green: "bg-[#059669]/15 text-[#10b981] border-[#059669]/40",
    red: "bg-[#DC2626]/15 text-[#f87171] border-[#DC2626]/40",
    gold: "bg-[#C9A24B]/15 text-[#C9A24B] border-[#C9A24B]/40",
    amber: "bg-amber-500/15 text-amber-400 border-amber-500/40",
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium border ${map[tone]}`}>
      {children}
    </span>
  );
}

export function readinessTone(pct, threshold = 60) {
  if (pct >= 90) return "green";
  if (pct < threshold) return "red";
  return "gold";
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      {Icon && <Icon className="h-10 w-10 text-slate-600 mb-4" />}
      <p className="text-slate-300 font-display text-lg">{title}</p>
      {hint && <p className="text-slate-500 text-sm mt-1 max-w-sm">{hint}</p>}
    </div>
  );
}
